import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getEventSliceContent = createAsyncThunk('/events/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getEvent`, {});
    return response;
})

export const eventSlice = createSlice({
    name: 'events',
    initialState: {
        isLoading: false,
        events : []
    },
    reducers: {
    },
    extraReducers: {
		[getEventSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getEventSliceContent.fulfilled]: (state, action) => {
			state.events = action.payload.data
			state.isLoading = false
		},
		[getEventSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default eventSlice.reducer